import PropTypes from 'prop-types'
import { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Checkbox } from '../reutilizables/checkbox/Checkbox'
import styles from './ModalTerminos.module.css'

const PDF_TYC = '/TerminosyCondicionesEBM.pdf'

export const ModalContenidoTerminos = ({
  show,
  onCerrar,
  onAceptar,
  onRechazar,
  enviando,
  soloLectura
}) => {
  const [aceptado, setAceptado] = useState(false)

  return (
    <Modal
      show={show}
      onHide={onCerrar}
      centered
      backdrop="static"
      keyboard={false}
      aria-labelledby="modal-contenido-tyc-titulo"
      className={styles.dialogContenido}
    >
      <Modal.Header closeButton>
        <Modal.Title id="modal-contenido-tyc-titulo">Términos y Condiciones de uso</Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-0">
        <iframe
          src={PDF_TYC}
          title="Términos y Condiciones"
          width="100%"
          className={`d-block border-0 ${styles.iframe}`}
        />
      </Modal.Body>

      {soloLectura ? (
        <Modal.Footer />
      ) : (
        <Modal.Footer className={`flex-column align-items-stretch gap-2 ${styles.footerContenido}`}>
          <Checkbox
            type="checkbox"
            name="aceptaTerminosContenido"
            label="He leído y acepto los Términos y Condiciones"
            checked={aceptado}
            onChange={() => setAceptado((prev) => !prev)}
            disabled={enviando}
          />
          <div className={`d-flex justify-content-end gap-2 ${styles.footerAcciones}`}>
            <Button variant="primary" onClick={onAceptar} disabled={!aceptado || enviando}>
              {enviando ? 'Guardando...' : 'Aceptar y continuar'}
            </Button>
            <Button variant="danger" onClick={onRechazar} disabled={enviando}>
              No acepto
            </Button>
          </div>
        </Modal.Footer>
      )}
    </Modal>
  )
}

ModalContenidoTerminos.propTypes = {
  show: PropTypes.bool.isRequired,
  onCerrar: PropTypes.func.isRequired,
  soloLectura: PropTypes.bool,
  onAceptar: PropTypes.func,
  onRechazar: PropTypes.func,
  enviando: PropTypes.bool
}
